import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { Product } from '../../../api/models/product';
import { updateAllVariantsSorting, useAppSelector } from '../../../redux';
import { SortingOptionsEnum } from '../../../utils/_enums/sorting-options.enum';
import { Select } from '../../_shared/select/select';
import styles from './upper-filter.module.scss';
import { useDigitalOriginalsPage } from '../../../api/hooks/useDigitalOriginalsPage.hook';

const UpperFilterDigitalOriginals = () => {
    const dispatch = useDispatch();
    const data = useDigitalOriginalsPage();
    const {
        control,
        setValue
    } = useForm<Product>({
        mode: 'onTouched'
    });
    const sorting = useAppSelector<SortingOptionsEnum>(
        (state) => state.productSlice.allVariantsSorting
    );

    useEffect(() => {
        setValue('categoryId', sorting);
    }, [sorting]);


    if (data) {
        return (
            <div className={styles['upper-filter']}>
                <div className={styles['sort-wrapper']}>
                    <Select
                        control={control}
                        label={data.sortBy?.fieldLabel}
                        placeholder={
                            data.sortBy?.fieldHint
                        }
                        onChange={(value) => dispatch(updateAllVariantsSorting(value.value))}
                        name="categoryId"
                        options={[
                            {
                                value: SortingOptionsEnum.TITLE_ASC,
                                label: data.sortByAlphabetAsc
                            }, {
                                value: SortingOptionsEnum.TITLE_DESC,
                                label: data.sortByAlphabetDesc
                            }, {
                                value: SortingOptionsEnum.DATE_ASC,
                                label: data.sortByReleaseAsc
                            }, {
                                value: SortingOptionsEnum.DATE_DESC,
                                label: data.sortByReleaseDesc
                            },
                        ]}
                    />
                </div>
            </div>
        );
    } else {
        return <div/>;
    }

}

export default UpperFilterDigitalOriginals;
